<template>
  <div>
    <p
      class="tw-block tw-text-center tw-text-eko-orange tw-text-left tw-text-lg tw--mb-3 tw-font-bold"
    >
      Select account type
    </p>
    <router-link to="/auth/register/lister">
      <v-card class="mx-auto tw-w-2/3 tw-my-2">
        <v-card-title
          class="tw-block tw-text-eko-orange tw-text-left tw-text-lg tw--mb-3 tw-font-bold"
          >Lister</v-card-title
        >
        <v-card-text class="">
          <div>
            This means you have non carbon emmiting projects. These are projects
            that aid the atmosphere and make the world a better place
          </div>
        </v-card-text>
      </v-card></router-link
    >

    <router-link to="/auth/register/offsetter">
      <v-card class="mx-auto tw-w-2/3 tw-my-4">
        <v-card-title
          class="tw-block tw-text-eko-orange tw-text-left tw-text-lg tw--mb-3 tw-font-bold"
          >Offsetter</v-card-title
        >
        <v-card-text class="">
          <div>
            This means that you are a carbon emmitter and in your bid to make
            the world a better place you cannot help but emmit carbon
          </div>
        </v-card-text>
      </v-card>
    </router-link>
<!-- 
    <router-link to="/auth/register/broker">
      <v-card class="mx-auto tw-w-2/3 tw-my-2">
        <v-card-title
          class="tw-block tw-text-eko-orange tw-text-left tw-text-lg tw--mb-3 tw-font-bold"
          >Broker</v-card-title
        >
        <v-card-text class="">
          <div>
            You function as an intermediary, you maintain projects for
            differents companies and well as yourself
          </div>
        </v-card-text>
      </v-card>
    </router-link> -->
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
